import type { FaireProductEntity } from "../../entity_types/product";

export const p_mz8a7uv2tr: FaireProductEntity = {
  token: "p_mz8a7uv2tr",
  type: "product",
  name: "16 oz Farmhouse Jar Soy Candle | Seasonal & Classic Scents",
  brandName: "Miller Farm Candle Co",
  imageUrl:
    "https://cdn.faire.com/fastly/eaed68ff5e05726ffde1da146946d776a245cb095d214d03e1fb12d5085dab76.png",
  priceDollars: 12.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/3a9a95f89c5d600d8633e1b649001ca700f50d3bac1e5902ecdc60a876374057.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
